import React from 'react';
import { connect } from 'react-redux';
import { updateData } from "../actions";
import ControlService from '../../helper/controlservice';
import * as moment from 'moment-timezone';
import jwtDecode from 'jwt-decode';

const uuidv4 = require('uuid/v4');

function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
class HiddenUI extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            data: {},
            refreshCount: {}
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {

        var nextData = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {};
        if (JSON.stringify(nextData) != JSON.stringify(prevState.data)) {
            return {
                data: nextData
            }
        }
        else return null; // Triggers no change in the state
    }
    componentDidUpdate(prevProps, prevState) {
        const { control, formid, action, token } = this.props;
        const data = this.props.data[formid] ? this.props.data[formid] : {};

        var _value = this.getValue(control, token, action, data);
        var value = prevProps.data && prevProps.data[formid] ? prevProps.data[formid][control.key] : null;
        if (ControlService().isEmptyorNull(value) && ControlService().isEmptyorNull(_value)) {
            value = '';
            _value = '';
        }
        if (control.sourcetype === 'parentformmodeljson' || control.sourcetype === 'guid' || control.sourcetype === 'datetime' || control.sourcetype === 'date') {
            if (!value) {
                this.setHiddenField();
            }
        }
        else if ((this.state.refreshCount[control.key] ? this.state.refreshCount[control.key] < 20 : true) && !control.stoprefresh && value != _value) {
            this.state.refreshCount[control.key] = (this.state.refreshCount[control.key] ? this.state.refreshCount[control.key] : 0) + 1
            this.setHiddenField();
        }
    }
    componentDidMount() {
        var value = this.props.data && this.props.data[this.props.formid] ? this.props.data[this.props.formid][this.props.control.key] : null;
        if (this.props.control.stoprefresh) {
            let skip = false;
            if (Array.isArray(value)) {
                if (value.length > 0) {
                    skip = true;
                }
            } else if (value && typeof value === 'object') {
                if (Object.keys(value).length > 0) {
                    skip = true;
                }
            } else if (value) {
                skip = true;
            }
            if (!skip) {
                this.setHiddenField();
            }
        } else {
            this.setHiddenField();
        }
        this.setState({ refreshCount: {} });
    }
    setHiddenField() {
        const { control, formid, action, token } = this.props;
        const data = this.props.data[formid] ? this.props.data[formid] : {};
        var value = null;
        try {
            value = this.getValue(control, token, action, data);
            if (control.setglobalvariable) {
                localStorage.setItem(control.key, value);
                // console.log(value);
            }
            this.props.update(control.key, value, formid);
        } catch (e) {
            this.props.update(control.key, value, formid);
        }
    }
    getValue(control, token, action, data) {
        var value;
        if (control.sourcetype == 'static') {
            value = this.getStaticValue(control);
            // console.log(value);
        } else if (control.sourcetype == 'urlpathname') {
            value = window.location.pathname;
            // console.log(value);
        } else if (control.sourcetype == 'getglobalvariable') {
            value = localStorage.getItem(control.key);
            if (value === 'null' || value === 'undefined') {
                value = null;
            }
            // console.log(value);
        } else if (control.sourcetype == 'pagevariable') {
            var currentUrl = control.pageurl ? control.pageurl : window.location.pathname;
            if (currentUrl.indexOf('/forms/Edit') > -1) {
                currentUrl = "/forms/Edit";
            }
            const menu = token && token.menu ? token.menu : {};
            const page = ControlService().find(menu['Nav'] ? menu['Nav'] : [], currentUrl.substring(1));

            if (page && page.Params) {
                page.Params.forEach(option => {
                    if (option.name == control.modelvalue) {
                        let paramVal = ControlService().GetParamUrl(option.name);
                        if (paramVal) {
                            value = paramVal;
                        } else {
                            value = option.value;
                        }
                    }
                });
            }
            // this.props.update(control.key, paramVal, formid);
        } else if (control.sourcetype === 'userid') {
            value = token.user ? token.user.id : '';
        } else if (control.sourcetype === 'email') {
            value = token.user ? token.user.email : '';
        } else if (control.sourcetype === 'guid') {
            value = uuidv4();
        } else if (control.sourcetype === 'date') {
            value = new Date().toLocaleDateString();
        } else if (control.sourcetype === 'datetime') {
            value = new Date().toJSON();
        } else if (control.sourcetype === 'timezone') {
            value = moment.tz.guess();
        } else if (control.sourcetype === 'day') {
            value = new Date().getDay();
        } else if (control.sourcetype === 'month') {
            value = (new Date().getMonth()) + 1;
        } else if (control.sourcetype === 'time') {
            value = new Date().toLocaleTimeString();
        } else if (control.sourcetype === 'CurrentMonthFirstDate') {
            var date = new Date();
            value = new Date(date.getFullYear(), date.getMonth(), 1)
        } else if (control.sourcetype === 'CurrentMonthLastDate') {
            var date = new Date();
            value = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        } else if (control.sourcetype === 'roleid') {
            value = token.user ? token.user.activerole : null;
            if (!value) {
                let role = token.user ? token.user.roles.find(x => x.roleid === token.user.activerole) : null;
                if (!role && token.user.activerole && Array.isArray(token.user.roles) && token.user.roles.length > 0) {
                    role = token.user.roles[0];
                }
                value = typeof role == 'object' ? role.rolename : role;
            }
        } else if (control.sourcetype === 'roles') {
            value = token.user ? token.user.roles : [];
        } else if (control.sourcetype === 'activeapp') {
            value = token.user ? token.user.ActiveApp : {};
        } else if (control.sourcetype === 'user') {
            value = token.user;
        } else if (control.sourcetype === 'tenantid') {
            let decodedIdToken = jwtDecode(token.apikey);
            value = decodedIdToken['extension_TenantId'];

        } else if (control.sourcetype === 'tenantname') {
            let decodedIdToken = jwtDecode(token.apikey);
            value = decodedIdToken['extension_TenantName'];

        } else if (control.sourcetype === 'rolename') {
            let role = token.user ? token.user.roles.find(x => x.roleid === token.user.activerole) : null;
            if (!role && token.user.activerole && Array.isArray(token.user.roles) && token.user.roles.length > 0) {
                role = token.user.roles[0];
            }
            value = typeof role == 'object' ? role.rolename : role;
        } else if (control.sourcetype === 'hierarchy') {
            const role = token.user ? token.user.roles.find(x => x.rolename == token.user.activerolename && x.roleid.toString() === token.user.activerole.toString()) : null;

            value = role && Array.isArray(role.roleslink) && role.roleslink.length > 0 ? role.roleslink[0].hierarchy : '';
        } else if (control.sourcetype === 'parentformmodel') {
            const _parentData = this.props.data[control.parentformid + action] ? this.props.data[control.parentformid + action] : {};
            value = _parentData[control.modelvalue];
        } else if (control.sourcetype === 'parentformmodeljson') {
            const _parentData = this.props.data[control.parentformid + action] ? this.props.data[control.parentformid + action] : {};

            value = _parentData;
        } else if (control.modelvalue) {
            if (control.modelvalue.includes(".")) {
                var model = control.modelvalue.split(".");
                if (model.length == 2) {
                    value = data[model[0]] ? data[model[0]][model[1]] : null;
                } else if (model.length == 3) {
                    value = data[model[0]] ? data[model[0]][model[1]][model[2]] : null;
                } else if (model.length == 4) {
                    value = data[model[0]] ? data[model[0]][model[1]][model[2]][model[3]] : null;
                }
            } else {
                value = data[control.modelvalue];
            }
        }
        return value;
    }

    getStaticValue(control) {
        var value = control.modelvalue ? control.modelvalue : "''";
        const reg = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (reg.test(value) && value.substring(0, 1) != "'") {
            try {
                return JSON.parse(value);
            } catch {
                return value;
            }
        }
        else {
            if (value.substring(0, 1) == "'") {
                return value.slice(1, -1);
            } else {
                if (isNaN(parseFloat(value)))
                    return value;
                else
                    return parseFloat(value);
            }
        }
    }
    render() {
        return (
            <React.Fragment>

            </React.Fragment>
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(HiddenUI);